import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-manual-access',
    templateUrl: './manual-access.component.html',
    styleUrls: ['./manual-access.component.scss'],
    standalone: false
})
export class ManualAccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
